module.exports = __webpack_public_path__ + "img/zapier.1ac2580c.png";